import { makeObservable, observable, action } from "mobx";
import { propertyBrowserApi } from "api-client";
import {
  PropertyBrowserBaseStore,
  PAGE_SIZE,
} from "./PropertyBrowserBaseStore";

export class OrganisationPropertyBrowserStore extends PropertyBrowserBaseStore {
  organisationId: string | null = null;

  constructor() {
    super();
    makeObservable(this, {
      nodeChildren: observable,
      loadingNodes: observable,
      searchQuery: observable,
      searchResults: observable,
      searchLoading: observable,
      searchTooGeneral: observable,
      reset: action,
      organisationId: observable,
      setOrganisationId: action,
    });
  }

  setOrganisationId(id: string) {
    if (this.organisationId !== id) this.reset();
    this.organisationId = id;
  }

  protected async fetchPage(parentNodeId: string | null, page: number) {
    if (!this.organisationId) return null;
    return (
      await propertyBrowserApi().mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes(
        this.organisationId,
        parentNodeId ?? undefined,
        undefined,
        page,
        PAGE_SIZE
      )
    ).data;
  }

  protected async fetchSearchResults(query: string, parentNodeId?: string) {
    if (!this.organisationId) return [];
    return (
      await propertyBrowserApi().mappingEditorApiV1RoutersPropertyBrowserOrganisationScopeNodes(
        this.organisationId,
        parentNodeId,
        query,
        1,
        PAGE_SIZE
      )
    ).data.items;
  }

  private static _instance: OrganisationPropertyBrowserStore;

  static getInstance(): OrganisationPropertyBrowserStore {
    if (!OrganisationPropertyBrowserStore._instance) {
      OrganisationPropertyBrowserStore._instance =
        new OrganisationPropertyBrowserStore();
    }
    return OrganisationPropertyBrowserStore._instance;
  }
}

export const organisationPropertyBrowserStore =
  OrganisationPropertyBrowserStore.getInstance();
